// Feedback #10 — dispatch to open the feedback panel already focused on a
// specific report.
//
// The bell's feedback.* notification kinds (status changes, retest
// requests, replies, verified fixes) have no in-app record page to link to
// — there's nowhere a `<a href>` could point. But an "actionable"
// destination already exists: cos-feedback-widget.openReport(id), built
// for the re-test email link's "come back to the report" leg (see
// utils/retestTarget.ts / services/retest-report.ts). This reuses that
// exact mechanism instead of navigating anywhere.
//
// Same window-CustomEvent convention as commands/navigate.ts's navigate()
// — cos-app-shell listens (literal string, to keep this module out of its
// own import graph — the cos:open-create-partner precedent) and forwards
// to the widget.

export const OPEN_FEEDBACK_REPORT_EVENT = 'cos:feedback:open-report';

export interface OpenFeedbackReportDetail {
	id: number;
}

/** Ask the feedback widget to open, focused on a specific report. */
export function openFeedbackReport(id: number): void {
	window.dispatchEvent(
		new CustomEvent<OpenFeedbackReportDetail>(OPEN_FEEDBACK_REPORT_EVENT, { detail: { id } }),
	);
}
